import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { clearError } from '@wikom/wikom-data';
import { resetLayout } from '../actions/layoutActions';
import useLocationChange from '../hooks/useLocationChange';
import FlashMessageModal from './FlashMessageModal';
var Page = function (_a) {
    var children = _a.children;
    var dispatch = useDispatch();
    var triggerLayoutResetOnPathnameChange = useCallback(function (location, prevLocation) {
        if (location.pathname && (prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.pathname) && location.pathname !== prevLocation.pathname) {
            dispatch(resetLayout());
            dispatch(clearError());
        }
    }, []);
    var clearErrorsOnLocationChange = useCallback(function () { return dispatch(clearError()); }, []);
    useLocationChange(triggerLayoutResetOnPathnameChange);
    useLocationChange(clearErrorsOnLocationChange);
    return (React.createElement("div", { id: "wrapper" },
        React.createElement(FlashMessageModal, null),
        React.createElement("div", { id: "page-content-wrapper" }, children)));
};
export default Page;
